var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.324C4 4.59333 4.59333 4 5.324 4H26.676C27.4067 4 28 4.59333 28 5.324V26.676C27.9996 27.027 27.86 27.3636 27.6118 27.6118C27.3636 27.86 27.027 27.9996 26.676 28H5.324C4.97296 27.9996 4.6364 27.86 4.38818 27.6118C4.13996 27.3636 4.00035 27.027 4 26.676V5.324ZM6.66667 6.66667V25.3333H25.3333V6.66667H6.66667ZM14.1627 11.22L20.668 15.556C20.7412 15.6047 20.8011 15.6707 20.8426 15.7482C20.8841 15.8256 20.9059 15.9121 20.9059 16C20.9059 16.0879 20.8841 16.1744 20.8426 16.2518C20.8011 16.3293 20.7412 16.3953 20.668 16.444L14.1613 20.78C14.0811 20.8332 13.988 20.8637 13.8918 20.8682C13.7957 20.8727 13.7001 20.8512 13.6152 20.8058C13.5303 20.7604 13.4593 20.6929 13.4097 20.6104C13.3601 20.528 13.3337 20.4336 13.3333 20.3373V11.6627C13.3335 11.5662 13.3599 11.4716 13.4095 11.3889C13.4592 11.3062 13.5304 11.2386 13.6155 11.1931C13.7006 11.1477 13.7965 11.1262 13.8928 11.131C13.9892 11.1357 14.0824 11.1665 14.1627 11.22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLine);
export default __webpack_public_path__ + "static/media/video-line.3a746547ca74cc501b53e06e03523ebe.svg";
export { ForwardRef as ReactComponent };